import React from "react";

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  filterOption: string;
  onFilterChange: (option: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  filterOption,
  onFilterChange,
}) => {
  return (
    <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center">
      {/* Filter Dropdown - Hidden on mobile, shown in table header instead */}
      <div className="relative hidden md:block">
        <select
          value={filterOption}
          onChange={(e) => onFilterChange(e.target.value)}
          className="h-10 w-full appearance-none rounded-lg border border-slate-200 bg-white px-4 pr-10 text-sm text-slate-700 sm:w-auto"
          style={{ minWidth: "80px" }}
        >
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
        <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m6 9 6 6 6-6"/>
          </svg>
        </div>
      </div>

      {/* Search Input */}
      <div className="relative w-full sm:w-auto">
        <div className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.3-4.3"/>
          </svg>
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search patients..."
          className="h-10 w-full rounded-lg border border-slate-200 bg-white pl-10 pr-4 text-base text-slate-700 placeholder:text-slate-400 focus:border-cyan-400 focus:outline-none sm:w-60 sm:text-sm md:w-80"
        />
      </div>
    </div>
  );
};

export default SearchBar;
